module.exports = __webpack_public_path__ + "static/media/reminder-bell.9abe8207.svg";